import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

import { makeStyles } from "@material-ui/core/styles";
import styles from "../../../assets/jss/components/tableStyle";
import {
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Button,
  TextField,
  Icon,
  FormControl,
  Grid,
  MenuItem,
  InputLabel,
  Select,
  FormHelperText,
  IconButton,
  Grow,
  Slide,
  Tooltip,
  Badge,
} from "@material-ui/core";
import CardBody from "../../../common/components/Card/CardBody";
import { DropzoneArea } from "material-ui-dropzone";
import Card from "../../../common/components/Card/Card";
import CardHeader from "../../../common/components/Card/CardHeader";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import { AuthorshipRepository } from "./AuthorshipRepository";
import {
  authorshipValidator,
  authorshipPointsValidator,
} from "./AuthorshipValidator";
import Upload from "../../../common/components/Upload";
import { LOCALE } from "../../../properties/Locale";
import GradingCommentComponent from "./GradingCommentComponent";
import { Alert, AlertTitle } from "@material-ui/lab";

const useStyles = makeStyles(styles);

export default function AuthorshipComponent(props) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [rerender, triggerRerender] = React.useState(false);
  const [btnDisabled, setBtnDisabled] = React.useState(false);
  const [authorshipRoles, setAuthorshipRoles] = React.useState();
  const [authorshipTypes, setAuthorshipTypes] = React.useState();

  const [authorshipData, setAuthorshipData] = React.useState([]);
  const [authorshipDataFormErrors, setAuthorshipDataFormErrors] =
    React.useState({});
  const [showCommentDialog, setShowCommentDialog] = React.useState(false);
  const [commentItem, setCommentItem] = React.useState();
  const [commentIndex, setCommentIndex] = React.useState();

  useEffect(() => {
    triggerRerender(!rerender);
  }, [authorshipDataFormErrors]);

  useEffect(() => {
    AuthorshipRepository.getAllRoles(props.gradingSchemaId).then((res) => {
      setAuthorshipRoles(res.data);
    });
    AuthorshipRepository.getAllTypes(props.gradingSchemaId).then((res) => {
      setAuthorshipTypes(res.data);
    });
    AuthorshipRepository.getAuthorshipData(props.vacancyAppId).then(
      (res) => {
        if (res.data.length > 0) setAuthorshipData(res.data);
      },
      (err) => {}
    );
  }, []);

  const addRow = () => {
    let data = authorshipData;
    data.push({
      laborName: "",
      type: { id: "" },
      publicationName: "",
      role: { id: "" },
      year: "",
      proofs: [],
    });
    setAuthorshipData(data);
    setAuthorshipDataFormErrors({});
    triggerRerender(!rerender);
  };

  const deleteRow = (index) => {
    let data = authorshipData;
    data.splice(index, 1);
    setAuthorshipData(data);
    setAuthorshipDataFormErrors({});
    triggerRerender(!rerender);
  };

  const handleChange = (event, index, name) => {
    let data = authorshipData;
    if (name == "type" || name == "role") {
      data[index][name]["id"] = event.target.value;
    } else {
      data[index][name] = event.target.value;
    }
    setAuthorshipData(data);
    triggerRerender(!rerender);
  };

  const handleChangeDate = (date, index, name) => {
    let data = authorshipData;
    data[index][name] = date;
    setAuthorshipData(data);
    triggerRerender(!rerender);
  };
  const handleClickNext = () => {
    setBtnDisabled(true);
    let data = authorshipData;
    var validFormData = true;
    for (var i = 0; i < data.length; i++) {
      if (!authorshipValidator.isValidSync(data[i])) {
        validFormData = false;
        break;
      }
    }
    if (validFormData) {
      saveData("next");
    } else {
      var validationErrors = [];
      (async () => {
        for (var i = 0; i < data.length; i++) {
          validationErrors[i] = {};
          await authorshipValidator
            .validate(data[i], { abortEarly: false })
            .catch((err) => {
              err.inner.forEach((validationError) => {
                validationErrors[i][validationError.path] = {};
                validationErrors[i][validationError.path].message =
                  validationError.message;
              });
            });
        }
      })();
      setBtnDisabled(false);
      setAuthorshipDataFormErrors(validationErrors);
    }
  };

  const handleClickPrev = () => {
    setBtnDisabled(true);
    let data = authorshipData;
    var validFormData = true;
    for (var i = 0; i < data.length; i++) {
      if (!authorshipValidator.isValidSync(data[i])) {
        validFormData = false;
        break;
      }
    }
    if (validFormData) {
      saveData("prev");
    } else {
      var validationErrors = [];
      (async () => {
        for (var i = 0; i < data.length; i++) {
          validationErrors[i] = {};
          await authorshipValidator
            .validate(data[i], { abortEarly: false })
            .catch((err) => {
              err.inner.forEach((validationError) => {
                validationErrors[i][validationError.path] = {};
                validationErrors[i][validationError.path].message =
                  validationError.message;
              });
            });
        }
      })();
      setBtnDisabled(false);
      setAuthorshipDataFormErrors(validationErrors);
    }
  };

  const saveData = (step) => {
    AuthorshipRepository.saveAuthorshipData(
      props.vacancyAppId,
      authorshipData
    ).then(
      (res) => {
        if (step === "next") {
          props.handleNextStep();
        } else {
          props.handlePreviousStep();
        }
      },
      (err) => {
        setBtnDisabled(false);
      }
    );
  };

  const addAttachments = (index, attachments) => {
    let data = authorshipData;
    data[index].proofs = attachments;
    setAuthorshipData(data);
  };

  const changePoints = (item) => {
    AuthorshipRepository.updatePoints(item.id, item.points).then((res) => {
      AuthorshipRepository.getAuthorshipData(props.vacancyAppId).then(
        (res) => {
          if (res.data.length > 0) {
            setAuthorshipData(res.data);
            setAuthorshipDataFormErrors({});
            triggerRerender(!rerender);
          }
        },
        (err) => {}
      );
    });
  };

  const unlockPoints = (item) => {
    AuthorshipRepository.unlockPoints(item.id).then((res) => {
      AuthorshipRepository.getAuthorshipData(props.vacancyAppId).then(
        (res) => {
          if (res.data.length > 0) {
            setAuthorshipData(res.data);
            triggerRerender(!rerender);
          }
        },
        (err) => {}
      );
    });
  };

  const evaluationNextStep = (data) => {
    var validFormData = true;
    for (var i = 0; i < data.length; i++) {
      if (!authorshipPointsValidator.isValidSync(data[i])) {
        validFormData = false;
        break;
      }
    }
    if (validFormData) {
      props.handleEvaluationNextStep(data, "authorship");
    } else {
      var validationErrors = [];
      (async () => {
        for (var i = 0; i < data.length; i++) {
          validationErrors[i] = {};
          await authorshipPointsValidator
            .validate(data[i], { abortEarly: false })
            .catch((err) => {
              err.inner.forEach((validationError) => {
                validationErrors[i][validationError.path] = {};
                validationErrors[i][validationError.path].message =
                  validationError.message;
              });
            });
        }
      })();
      setBtnDisabled(false);
      setAuthorshipDataFormErrors(validationErrors);
    }
  };

  const openCommentDialog = (item, index) => {
    setCommentItem(item);
    setCommentIndex(index);
    setShowCommentDialog(true);
  };

  const closeCommentDialog = (item, index) => {
    if (item != undefined) {
      AuthorshipRepository.setComment(item.id, item.comment).then((res) => {
        let tmp = authorshipData;
        tmp[index] = item;
        setAuthorshipData(tmp);
        triggerRerender(!rerender);
        setShowCommentDialog(false);
      });
    } else {
      setShowCommentDialog(false);
    }
  };

  return (
    <div>
      {!props.disabled && (
        <Alert
          style={{ marginBottom: "45px", marginTop: "10px" }}
          fullwidth="true"
          severity="info"
        >
          <AlertTitle>{LOCALE.authorships_info_title}</AlertTitle>
          {LOCALE.authorships_info_description}
        </Alert>
      )}
      <Card>
        <CardHeader
          color="theme"
          style={{ padding: "8px", paddingLeft: "15px" }}
        >
          <Grid container>
            <Grid item xs={8}>
              {" "}
              <Typography>
                Список на докази за професионален развој, област АВТОРСТВО
              </Typography>
            </Grid>
            <Grid item xs={2}></Grid>
            <Grid item xs={2}>
              {" "}
              {!props.disabled && (
                <Button
                  color="default"
                  variant="contained"
                  className={authorshipData.length == 0 ? "bounceButton" : ""}
                  startIcon={<Icon>add_circle_outline</Icon>}
                  size="small"
                  aria-label="create"
                  style={{ float: "right" }}
                  onClick={addRow}
                >
                  {LOCALE.add_authorship}
                </Button>
              )}
            </Grid>
          </Grid>
        </CardHeader>
        <CardBody>
          <Table aria-label="groups table" className={classes.table}>
            <TableHead>
              <TableRow className={classes.tableHeadRow}>
                <TableCell
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.num}
                </TableCell>
                <TableCell
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.authorship_title}
                </TableCell>
                <TableCell
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.authorship_publication_type}
                </TableCell>
                <TableCell
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.authorship_publication_title}
                </TableCell>
                <TableCell
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.authorship_role}
                </TableCell>
                <TableCell
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.authorship_release_year}
                </TableCell>

                <TableCell
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.proof}
                </TableCell>
                <TableCell
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.actions}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {authorshipData.length > 0 ? (
                authorshipData.map((item, index) => (
                  <TableRow
                    key={index}
                    className={classes.tableBodyRow}
                    style={index % 2 ? { background: "#f0f0f0" } : {}}
                  >
                    <TableCell className={classes.tableCell}>
                      {index + 1}
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      <Tooltip
                        title={item.laborName}
                        style={{ color: "white" }}
                        disableHoverListener={!props.evaluation}
                      >
                        <TextField
                          value={item.laborName}
                          variant="outlined"
                          label={LOCALE.authorship_title}
                          disabled={props.disabled}
                          error={authorshipDataFormErrors[index]?.laborName}
                          helperText={
                            authorshipDataFormErrors[index]?.laborName?.message
                          }
                          size="small"
                          onChange={(e) => handleChange(e, index, "laborName")}
                        />
                      </Tooltip>
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      <Tooltip
                        title={item.type.name}
                        style={{ color: "white" }}
                        disableHoverListener={!props.evaluation}
                      >
                        <FormControl
                          disabled={props.disabled}
                          className={classes.formControl}
                          variant="outlined"
                          error={
                            authorshipDataFormErrors[index] &&
                            authorshipDataFormErrors[index]["type.id"]
                          }
                          size="small"
                          style={{ width: "250px" }}
                        >
                          <InputLabel id="demo-simple-select-label">
                            {LOCALE.authorship_publication_type}
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            label={LOCALE.authorship_publication_type}
                            value={item.type.id}
                            onChange={(e) => handleChange(e, index, "type")}
                          >
                            {authorshipTypes?.map((item, index) => (
                              <MenuItem value={item.id} key={index}>
                                {item.name}
                              </MenuItem>
                            ))}
                          </Select>
                          <FormHelperText id="municipality-helper-text">
                            {authorshipDataFormErrors[index] &&
                              authorshipDataFormErrors[index]["type.id"]
                                ?.message}
                          </FormHelperText>
                        </FormControl>
                      </Tooltip>
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      <Tooltip
                        title={item.publicationName}
                        style={{ color: "white" }}
                        disableHoverListener={!props.evaluation}
                      >
                        <TextField
                          disabled={props.disabled}
                          value={item.publicationName}
                          variant="outlined"
                          label={LOCALE.authorship_publication_title}
                          error={
                            authorshipDataFormErrors[index]?.publicationName
                          }
                          helperText={
                            authorshipDataFormErrors[index]?.publicationName
                              ?.message
                          }
                          size="small"
                          onChange={(e) =>
                            handleChange(e, index, "publicationName")
                          }
                        />
                      </Tooltip>
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      <Tooltip
                        title={item.role.name}
                        style={{ color: "white" }}
                        disableHoverListener={!props.evaluation}
                      >
                        <FormControl
                          disabled={props.disabled}
                          className={classes.formControl}
                          variant="outlined"
                          error={
                            authorshipDataFormErrors[index] &&
                            authorshipDataFormErrors[index]["role.id"]
                          }
                          size="small"
                          style={{ width: "250px" }}
                        >
                          <InputLabel id="demo-simple-select-label">
                            {LOCALE.authorship_role}
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            label={LOCALE.authorship_role}
                            value={item.role.id}
                            onChange={(e) => handleChange(e, index, "role")}
                          >
                            {authorshipRoles?.map((item, index) => (
                              <MenuItem value={item.id} key={index}>
                                {item.name}
                              </MenuItem>
                            ))}
                          </Select>
                          <FormHelperText id="municipality-helper-text">
                            {authorshipDataFormErrors[index] &&
                              authorshipDataFormErrors[index]["role.id"]
                                ?.message}
                          </FormHelperText>
                        </FormControl>
                      </Tooltip>
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      <Tooltip
                        title={item.year}
                        style={{ color: "white" }}
                        disableHoverListener={!props.evaluation}
                      >
                        <TextField
                          disabled={props.disabled}
                          value={item.year}
                          variant="outlined"
                          label={LOCALE.authorship_release_year}
                          error={authorshipDataFormErrors[index]?.year}
                          helperText={
                            authorshipDataFormErrors[index]?.year?.message
                          }
                          size="small"
                          onChange={(e) => handleChange(e, index, "year")}
                        />
                      </Tooltip>
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      <FormControl
                        disabled={props.disabled}
                        className={classes.formControl}
                        variant="outlined"
                        error={
                          authorshipDataFormErrors[index] &&
                          authorshipDataFormErrors[index]["proofs"]
                        }
                        size="small"
                      >
                        <Upload
                          vacancyAppDomain={"AUTHORSHIP"}
                          vacancyAppId={props.vacancyAppId}
                          attachments={item.proofs}
                          onComponentClose={addAttachments}
                          rowIndex={index}
                          disabled={props.disabled}
                        />
                        <FormHelperText id="municipality-helper-text">
                          {authorshipDataFormErrors[index] &&
                            authorshipDataFormErrors[index]["proofs"]?.message}
                        </FormHelperText>{" "}
                      </FormControl>
                    </TableCell>
                    {props.showPoints && (
                      <React.Fragment>
                        <TableCell className={classes.tableCell}>
                          <TextField
                            disabled={true}
                            value={item.points}
                            variant="outlined"
                            label={LOCALE.points}
                            style={{ maxWidth: "80px" }}
                            size="small"
                          />
                        </TableCell>
                      </React.Fragment>
                    )}
                    {!props.disabled && (
                      <TableCell className={classes.tableCell}>
                        <IconButton
                          disabled={props.disabled}
                          color="secondary"
                          size="small"
                          aria-label="delete"
                          onClick={() => deleteRow(index)}
                        >
                          <Icon>delete</Icon>
                        </IconButton>
                        {/* {props.status === "ADDITIONAL_DATA_REQUIRED" && (
                          <Tooltip
                            title={LOCALE.comment}
                            aria-label={LOCALE.comment}
                          >
                            <Badge
                              badgeContent={item.comment ? 1 : 0}
                              color="secondary"
                            >
                              <IconButton
                                color="primary"
                                size="small"
                                style={{ top: "5px" }}
                                onClick={() => openCommentDialog(item, index)}
                              >
                                <Icon>message</Icon>
                              </IconButton>
                            </Badge>
                          </Tooltip>
                        )} */}
                      </TableCell>
                    )}
                    {props.evaluation && (
                      <TableCell className={classes.tableCell} width={150}>
                        <FormControl
                          style={{ display: "inline" }}
                          error={
                            authorshipDataFormErrors[index] &&
                            authorshipDataFormErrors[index]["pointsChecked"]
                          }
                        >
                          <TextField
                            disabled={item.pointsChecked}
                            value={item.points}
                            variant="outlined"
                            label="Поени"
                            style={{ maxWidth: "80px" }}
                            size="small"
                            onChange={(e) => handleChange(e, index, "points")}
                          />
                          {!item.pointsChecked && (
                            <Tooltip
                              title={LOCALE.confirm_points}
                              aria-label={LOCALE.confirm_points}
                            >
                              <IconButton
                                style={{ color: "green", top: "5px" }}
                                size="small"
                                onClick={() => changePoints(item)}
                              >
                                <Icon>check</Icon>
                              </IconButton>
                            </Tooltip>
                          )}
                          {item.pointsChecked && (
                            <Tooltip
                              title={LOCALE.change_points}
                              aria-label={LOCALE.change_points}
                            >
                              <IconButton
                                style={{ color: "red", top: "5px" }}
                                size="small"
                                onClick={() => unlockPoints(item)}
                              >
                                <Icon>clear</Icon>
                              </IconButton>
                            </Tooltip>
                          )}
                          <Tooltip
                            title={LOCALE.comment}
                            aria-label={LOCALE.comment}
                          >
                            <Badge
                              badgeContent={item.comment ? 1 : 0}
                              color="secondary"
                            >
                              <IconButton
                                color="primary"
                                size="small"
                                style={{ top: "5px" }}
                                onClick={() => openCommentDialog(item, index)}
                              >
                                <Icon>message</Icon>
                              </IconButton>
                            </Badge>
                          </Tooltip>
                          <FormHelperText id="municipality-helper-text">
                            {authorshipDataFormErrors[index] &&
                              authorshipDataFormErrors[index]["pointsChecked"]
                                ?.message}
                          </FormHelperText>{" "}
                        </FormControl>
                      </TableCell>
                    )}
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={12}>
                    <Icon style={{ verticalAlign: "bottom", color: "orange" }}>
                      warning
                    </Icon>{" "}
                    {LOCALE.no_authorships_added}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </CardBody>
      </Card>
      {!props.disabled && (
        <div>
          <Button
            color="secondary"
            variant="contained"
            disabled={btnDisabled}
            style={{ marginRight: "5px", float: "right" }}
            size="small"
            onClick={() => handleClickNext()}
          >
            {LOCALE.next}
          </Button>
          <Button
            style={{ marginRight: "5px", float: "right" }}
            color="secondary"
            variant="outlined"
            disabled={btnDisabled}
            size="small"
            onClick={() => handleClickPrev()}
          >
            {LOCALE.previous}
          </Button>
        </div>
      )}
      {props.evaluation && (
        <div>
          <Button
            color="primary"
            variant="contained"
            style={{ marginRight: "5px", float: "right" }}
            size="small"
            disabled={btnDisabled}
            onClick={() => evaluationNextStep(authorshipData)}
          >
            {LOCALE.next}
          </Button>
        </div>
      )}
      {showCommentDialog && (
        <GradingCommentComponent
          item={commentItem}
          preview={props.status === "ADDITIONAL_DATA_REQUIRED" ? true : false}
          index={commentIndex}
          handleClose={(item, index) => closeCommentDialog(item, index)}
        />
      )}
    </div>
  );
}
